import type { Comparacion } from '../../lib/comparacion.ts';
import { textoDeCambio } from '../../lib/comparacion.ts';
import { Badge, Card } from '../ui/index.ts';

export function KpiCard({
  label,
  value,
  color,
  comparacion,
  sentidoInverso = false,
}: {
  label: string;
  /** Los números se formatean con locale es-CO; los strings se muestran tal cual. */
  value: number | string;
  color: string;
  /**
   * Contra el período anterior. `null` o ausente no dibuja nada: no todos los
   * KPI tienen serie diaria de la cual sacarlo, y los que la tienen a veces no
   * pueden compararse honestamente (ver `compararConPeriodoAnterior`).
   */
  comparacion?: Comparacion | null;
  /** Para métricas donde subir es malo — escalamiento, tiempo de espera. */
  sentidoInverso?: boolean;
}) {
  return (
    <Card
      variant="default"
      className="p-5 flex flex-col h-full border-l-4"
      style={{ borderLeftColor: color }}
    >
      <p className="text-xs text-content-tertiary uppercase tracking-wider font-mono mb-2">
        {label}
      </p>
      <p style={{ color }} className="text-3xl font-bold tabular-nums mb-2">
        {typeof value === 'number' ? value.toLocaleString('es-CO') : value}
      </p>
      {comparacion && (
        <div className="mt-auto">
          <Badge color={colorDelBadge(comparacion.sentido, sentidoInverso)}>
            {textoDeCambio(comparacion)}
          </Badge>
          <span className="text-xs text-content-tertiary ml-2">
            vs. {comparacion.anterior.toLocaleString('es-CO')} antes
          </span>
        </div>
      )}
    </Card>
  );
}

function colorDelBadge(
  sentido: Comparacion['sentido'],
  inverso: boolean,
): 'success' | 'danger' | 'neutral' {
  if (sentido === 'estable') return 'neutral';
  const bueno = sentido === 'sube' ? !inverso : inverso;
  return bueno ? 'success' : 'danger';
}
